import { RequestError } from "./error/requestError"
import { abortController } from "./request"

type methodType = "POST" | "GET" | "FETCH" | "DELETE"

interface RequestParams {
    fullUrl: string
    method: methodType
}

export class HttpRequest {
    url: string
    timeout = 5000

    constructor(url: string) {
        this.url = url
    }

    private async request(requestParams: RequestParams, body?: any) {
        try {
            const { controller, timer } = abortController(this.timeout)

            const response = await fetch(requestParams.fullUrl, {
                method: requestParams.method,
                headers: {
                    "Content-Type": "application/json"
                },
                signal: controller?.signal,
                body: body
            })

            clearTimeout(timer)

            if (response.status != 200)
                throw new Error(
                    `[API ERROR] - ${response.status}: ${response.statusText} `
                )

            const data = await response.json()

            return data
        } catch (error: any) {
            console.error(error)

            if (error instanceof Error) {
                throw new RequestError({
                    error,
                    method: requestParams.method,
                    url: requestParams.fullUrl,
                    body
                })
            }

            throw new Error(
                error?.message ??
                    `[API ERROR] - method: ${requestParams.method} url: ${requestParams.fullUrl}`
            )
        }
    }

    async post<K>(path: string, body: any): Promise<K> {
        const data = await this.request(
            { fullUrl: this.url + path, method: "POST" },
            body
        )

        return data as K
    }

    async get<K>(path: string): Promise<K> {
        const data = await this.request({
            fullUrl: this.url + path,
            method: "GET"
        })

        return data as K
    }

    async fetch<K>(path: string, body: any): Promise<K> {
        const data = await this.request(
            { fullUrl: this.url + path, method: "FETCH" },
            body
        )

        return data as K
    }

    async delete<K>(path?: string): Promise<K> {
        const data = await this.request({
            fullUrl: this.url + path,
            method: "DELETE"
        })

        return data as K
    }
}
